<template>
	<div class="container">
		<div class="fl-between-al" style="width: 1200px;margin: 0 auto;height: 100%;">
			<div class="left-logo fl-al">
				<img src='@/assets/images/wc-logo.png' />
			</div>
			<div class="two-where fl-al">
				<router-link to="/list" class="where-one"
					:class="{ 'be-choosed': $route.name === 'course' }">课程</router-link>
				<router-link to="/appDownInfo" class="where-one"
					:class="{ 'be-choosed': $route.path === '/appDownInfo' }">下载</router-link>
				<!-- <div class="where-one " :class="[nowLink == 'list' ? 'be-choosed' : '']" @click="toLink('list')">
					课程
					<div class="line">
						
					</div>
				</div>
				<div class="where-one " :class="[nowLink == 'appDownInfo' ? 'be-choosed' : '']" @click="toLink('appDownInfo')">
					下载
					<div class="line">
						
					</div>
				</div> -->
			</div>
			<div class="right-thing fl-al">

				<el-popover placement="top-start" width="254" trigger="hover" :disabled='!isLoggedIn' >
					<div class="move-block" v-if="isLoggedIn">
						<div class="move-one " style="margin-bottom: 30px;">
							<img src='../assets/icons/user-icon.png' />
							{{userInfo.phone || ''}}
						</div>
						<div class="move-one txt-act" @click="showQuit">
							<img src='../assets/icons/quit-icon.png' />
							退出登录
						</div>
					</div>

					<div class="avatar-name fl-al" slot="reference" @click="showLogin">
						<img :src="userInfo.avatar" alt="" v-if="userInfo.avatar" />
						<div class="iimg" v-else>
							
						</div>
						<div class="name">
							{{userInfo.nickName || '游客123'}}
						</div>
					</div>
				</el-popover>
			</div>
		</div>
		<el-dialog title="确认退出" :visible.sync="dialogVisible" width="30%" :before-close="handleBeforeClose"
			:z-index="1000" :modal='false'>
			<span>确定要退出登录吗？</span>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmExit">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog content="提示" :visible.sync="quitOkShow" width="30%" :before-close="handleBeforeClose"
			:z-index="1001" :modal='false'>
			<div style="font-size: 28px;">退出成功!</div>
		</el-dialog>
	</div>

</template>

<script>
	import { exitLoginApi} from '@/api/user/user';
	import { Toast,debounceNew } from '@/utils/index';
	import { mapState, mapActions } from 'vuex';
	export default {
		name: 'CommonHead',
		props: {
		  // userInfo:Object
		},
		components: {
		},
		data() {
			return {
				nowLink: 'list',
				dialogVisible: false,
				quitOkShow:false,
				// userInfo:JSON.parse(localStorage.getItem('userInfo')) || {userId,avatar,nickName,phone}
			}
		},
		created() {
			console.log('s是否登录：',this.isLoggedIn);
			setTimeout(()=>{
				console.log('s是否登录：',this.isLoggedIn);
			},1000)
		},
		computed: {
		  ...mapState(['isLoggedIn','userInfo'])
		},
		methods: {
			...mapActions(['login', 'logout']),
			toLink(e) {
				this.nowLink = e
				this.$router.push({
					path: e
				});
			},
			showLogin(){
				if(this.isLoggedIn){
					return false
				}
				this.$emit('showLogin')
			},
			showQuit() {
				this.dialogVisible = true;
			},
			confirmExit() {
				// 处理退出逻辑
				exitLoginApi().then(res=>{
					console.log(res);
					if(res.code === 200){
						this.dialogVisible = false;
						this.quitOkShow = true
						localStorage.removeItem('userInfo');
						localStorage.removeItem('token');
						this.logout()
					}
				})
				
			},
			handleBeforeClose(done) {
				// 处理关闭弹框逻辑
				done(); // 关闭弹框
			}
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		// max-width: 1920px;
		width: 1320px;
		margin: 0 auto;
		height: 100%;
		overflow-x: auto;
	}

	.left-logo {
		width: 80px;
		height: 80px;

		img {
			width: 80px;
			height: 80px;
			border-radius: 50%;
		}
	}

	.two-where {
		margin-left: 89px;
		.where-one:hover{
			color: #01BF5C;
		}
		.where-one {
			font-family: ABeeZee, ABeeZee;
			font-weight: 400;
			font-size: 32px;
			color: #000000;
			line-height: 38px;
			text-align: left;
			font-style: normal;
			margin-right: 78px;
			position: relative;
			cursor: pointer;
			text-decoration: none;

			&:after {
				content: '';
				width: 0;
				height: 3px;
				background-color: transparent;
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translateX(-50%);
				transition: width 0.1s ease-in-out, background-color 0.1s ease-in-out;
			}

			&.be-choosed:after {
				border-radius: 20px 20px 20px 20px;
				width: 70px;
				background: linear-gradient( 138deg, #1FED83 0%, #19C76C 100%);
				height: 9px;
				// position: relative;
				bottom: -25px;
			}
		}

		.be-choosed {
			color: #01BF5C;
			
			.line {
				width: 70px;
				height: 9px;
				background: linear-gradient( 138deg, #1FED83 0%, #19C76C 100%);
				border-radius: 20px 20px 20px 20px;
				position: absolute;
				bottom: -22px;
			}
		}
	}

	.move-block {
		padding-top: 20px;
		padding-bottom: 20px;
		padding-left: 12px;
	}

	.move-one {
		display: flex;
		align-items: center;
		height: 31px;

		img {
			width: 24px;
			height: 24px;
			margin-right: 12px;
		}

		font-family: ABeeZee,
		ABeeZee;
		font-weight: 400;
		font-size: 26px;
		color: #626262;
	}

	.right-thing {
		flex: 1;
		justify-content: flex-end;

		.avatar-name {
			cursor: pointer;

			img {
				background: #D5F2FF;
				width: 48px;
				height: 48px;
				border-radius: 50%;
				margin-right: 14px;
			}
			.iimg{
				background: #D5F2FF;
				width: 48px;
				height: 48px;
				border-radius: 50%;
				margin-right: 14px;
			}
			.name {
				color: #333333;
				font-size: 16px;
			}
		}
	}
</style>